import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { CierreVentasContent } from './components/CierreVentasContent';

export default function CierreVentas() {

    return (
        <MainContent
            component={<CierreVentasContent />}
            titulo='Cierre de ventas'
            noBackground
            tableMaxWidth
            mainContentWhite
        />
    );

};
